import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import LoginModal from "../components/LoginModal";
import {
  FaUser,
  FaBuilding,
  FaFileAlt,
  FaSearch,
  FaPaperPlane,
  FaUsers,
  FaCheckCircle,
  FaShieldAlt,
  FaUserPlus,
  FaClock,
  FaHeadset,
  FaArrowRight,
} from "react-icons/fa";
import HireCuraIcon from "../assets/hirecura-icon.png";

import Footer from "../components/Footer";
import healthcareHero from "../assets/how-it-works-hero.png";

function HowItWorks() {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
const [loginRole, setLoginRole] = useState("candidate");

const openLoginModal = (role) => {
  setLoginRole(role);
  setShowLoginModal(true);
};

  const [loggedUser, setLoggedUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });

  return (
    <div className="min-h-screen bg-white">

      {/* ================= HEADER ================= */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">

        <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3 sm:py-4">

          <div className="flex w-full min-w-0 items-center justify-between gap-3">

            {/* LOGO */}
            {/* LOGO */}
<div
  className="cursor-pointer flex min-w-0 items-center gap-2 sm:gap-3 flex-shrink-0"
  onClick={() =>
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
>
  {/* HireCura Icon */}
  <img
    src={HireCuraIcon}
    alt="HireCura Icon"
    className="h-9 w-9 sm:h-11 sm:w-11 md:h-12 md:w-12 object-contain"
  />

  {/* Brand Name and Tagline */}
  <div className="flex flex-col">
    <h1 className="text-xl sm:text-2xl md:text-3xl font-bold tracking-tight leading-none">
      <span className="text-slate-900">Hire</span>
      <span className="text-teal-600">Cura</span>
    </h1>

    <p className="text-[8px] sm:text-[10px] md:text-xs text-slate-500 font-medium tracking-wide mt-1">
      Where Careers Meet Care.
    </p>
  </div>
</div>


            {/* NAVIGATION */}
            <nav className="hidden lg:flex items-center gap-8">

              <button
                onClick={() => navigate("/")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Home
              </button>

              <button
                onClick={() => navigate("/find-jobs")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Find Jobs
              </button>

              {loggedUser?.role !== "candidate" && (
  <button
    onClick={() => navigate("/for-employers")}
    className="text-gray-700 hover:text-teal-600 transition font-medium"
  >
    For Employers
  </button>
)}

              {/* ACTIVE */}
              <button
                className="relative text-teal-600 font-semibold"
              >
                How It Works

                <span className="absolute -bottom-5 left-0 right-0 h-[3px] bg-teal-600 rounded-full" />
              </button>

              <button
                onClick={() => navigate("/about-us")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                About Us
              </button>

              <button
                onClick={() => navigate("/contact-us")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Contact Us
              </button>

            </nav>


            {/* RIGHT SIDE */}
            
<div className="hidden md:flex items-center gap-4">
  {loggedUser ? (
    
    <>
    <FaUser className="text-[#10243e] text-lg" />

      <span className="hidden xl:block text-sm font-semibold text-gray-700">
        Welcome, {loggedUser.name || "User"}
      </span>

      <button
        onClick={() =>
          navigate(
            loggedUser.role === "institution"
              ? "/institution"
              : "/candidate-dashboard"
          )
        }
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Dashboard
      </button>

      <button
        onClick={() => {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          setLoggedUser(null);
          navigate("/");
        }}
        className="border border-red-500 text-red-600 px-5 py-2 rounded-full hover:bg-red-50 transition"
      >
        Logout
      </button>
    </>
  ) : (
    <>
      <FaUser className="text-[#10243e] text-lg" />

      <button
        onClick={() => openLoginModal("candidate")}
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Login
      </button>

      <button
        onClick={() => openLoginModal("institution")}
        className="bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 transition"
      >
        Post a Job
      </button>
    </>
  )}
</div>


            <MobileMenu
              onLogin={() => openLoginModal("candidate")}
              loggedUser={loggedUser}
              onLogout={() => {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                setLoggedUser(null);
                navigate("/");
              }}
            />
          </div>

        </div>
      </header>


      {/* ================= HERO ================= */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-[#f3fbfa] to-[#dff5f1]">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="grid lg:grid-cols-2 gap-5 sm:gap-10 items-center min-h-0 lg:min-h-[390px]">

            {/* LEFT */}
            <div className="relative z-10 py-8 sm:py-14">

              <p className="text-xs sm:text-sm md:text-base tracking-[0.16em] sm:tracking-[0.18em] text-[#10243e] font-medium mb-3 sm:mb-4">
                HOW IT WORKS
              </p>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold leading-tight sm:leading-[1.08] text-[#10243e]">

                A Simple Way to
                <br />

                Build{" "}
                <span className="text-teal-600">
                  Healthcare Careers
                </span>

              </h1>

              <p className="mt-3 sm:mt-5 text-base sm:text-lg text-gray-600 max-w-xl leading-6 sm:leading-7">
                HireCura connects healthcare professionals with trusted
                hospitals and healthcare employers across India —
                quickly, easily and transparently.
              </p>

            </div>


            {/* RIGHT IMAGE */}
            <div className="relative hidden md:flex justify-end items-end h-full min-h-[390px]">

              <div className="absolute right-[-80px] bottom-0 w-[620px] h-[350px] bg-teal-100/70 rounded-t-full" />

              <img
                src={healthcareHero}
                alt="Healthcare professionals"
                className="relative z-10 w-full max-w-[560px] h-[330px] object-cover object-top rounded-t-[180px]"
              />

            </div>

          </div>

        </div>

      </section>


      {/* ================= CANDIDATE + EMPLOYER ================= */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-4 md:py-6">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-5">


          {/* ================= CANDIDATES ================= */}
          <div className="bg-gradient-to-br from-[#effcf9] to-[#f7fffd] rounded-2xl p-4 sm:p-6 md:p-7 border border-teal-50">

            {/* TITLE */}
            <div className="flex items-start gap-3 sm:gap-4 min-w-0">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e0f8f3] flex items-center justify-center flex-shrink-0">
                <FaUser className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div className="min-w-0 flex-1">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#10243e] leading-tight">
                  For Candidates
                </h2>

                <p className="text-sm sm:text-base text-gray-600 mt-1 leading-5 sm:leading-normal">
                  Find and apply for the right healthcare opportunities
                   <span className="md:hidden"> </span><br className="hidden md:block" />
                  in simple steps.
                </p>
              </div>

            </div>


            {/* STEPS */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-3 mt-7 sm:mt-7">

              {/* STEP 1 */}
              <div className="relative min-w-0">

                <div className="absolute top-3 left-3 sm:-top-5 sm:left-1/2 sm:-translate-x-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#e5f8f4] border border-teal-200 flex items-center justify-center font-bold text-teal-600 z-10">
                  1
                </div>

                <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-5 pt-8 sm:pt-9 text-center min-h-0 md:min-h-[180px] flex flex-col items-center">

                  <FaUserPlus className="text-3xl sm:text-4xl text-teal-600 mx-auto mb-2 sm:mb-3" />

                  <h3 className="font-bold text-[#10243e]">
                    Create Your Profile
                  </h3>

                  <p className="text-sm text-gray-500 mt-2 leading-5">
                    Sign up and build your profile with your skills,
                    experience and preferences.
                  </p>

                </div>

              </div>


              {/* STEP 2 */}
              <div className="relative min-w-0">

                <div className="absolute top-3 left-3 sm:-top-5 sm:left-1/2 sm:-translate-x-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#e5f8f4] border border-teal-200 flex items-center justify-center font-bold text-teal-600 z-10">
                  2
                </div>

                <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-5 pt-8 sm:pt-9 text-center min-h-0 md:min-h-[180px] flex flex-col items-center">

                  <FaSearch className="text-3xl sm:text-4xl text-teal-600 mx-auto mb-2 sm:mb-3" />

                  <h3 className="font-bold text-[#10243e]">
                    Search Jobs
                  </h3>

                  <p className="text-sm text-gray-500 mt-2 leading-5">
                    Find jobs by profession, location and specialization
                    across trusted employers.
                  </p>

                </div>

              </div>


              {/* STEP 3 */}
              <div className="relative min-w-0">

                <div className="absolute top-3 left-3 sm:-top-5 sm:left-1/2 sm:-translate-x-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#e5f8f4] border border-teal-200 flex items-center justify-center font-bold text-teal-600 z-10">
                  3
                </div>

                <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-5 pt-8 sm:pt-9 text-center min-h-0 md:min-h-[180px] flex flex-col items-center">

                  <FaPaperPlane className="text-3xl sm:text-4xl text-teal-600 mx-auto mb-2 sm:mb-3" />

                  <h3 className="font-bold text-[#10243e]">
                    Apply & Connect
                  </h3>

                  <p className="text-sm text-gray-500 mt-2 leading-5">
                    Apply for jobs and connect directly with employers.
                  </p>

                </div>

              </div>

            </div>


            {/* FIND JOBS BUTTON */}
            <div className="flex justify-center mt-5 sm:mt-6">

              <button
                onClick={() => navigate("/find-jobs")}
                className="w-full sm:w-auto justify-center bg-teal-600 hover:bg-teal-700 text-white px-6 sm:px-10 py-3 rounded-xl font-semibold flex items-center gap-3 transition"
              >
                Find Jobs
                <FaArrowRight className="text-sm" />
              </button>

            </div>

          </div>


          {/* ================= EMPLOYERS ================= */}
          <div className="bg-gradient-to-br from-[#f0f8ff] to-[#f8fbff] rounded-2xl p-4 sm:p-6 md:p-7 border border-blue-50">

            {/* TITLE */}
            <div className="flex items-start gap-3 sm:gap-4 min-w-0">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e4f1ff] flex items-center justify-center flex-shrink-0">
                <FaBuilding className="text-2xl sm:text-3xl text-blue-600" />
              </div>

              <div className="min-w-0 flex-1">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#10243e] leading-tight">
                  For Employers
                </h2>

                <p className="text-sm sm:text-base text-gray-600 mt-1 leading-5 sm:leading-normal">
                  Hire qualified healthcare professionals quickly
                   <span className="md:hidden"> </span><br className="hidden md:block" />
                  and efficiently.
                </p>
              </div>

            </div>


            {/* STEPS */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-3 mt-7 sm:mt-7">

              {/* STEP 1 */}
              <div className="relative min-w-0">

                <div className="absolute top-3 left-3 sm:-top-5 sm:left-1/2 sm:-translate-x-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#e4f1ff] border border-blue-200 flex items-center justify-center font-bold text-blue-600 z-10">
                  1
                </div>

                <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-5 pt-8 sm:pt-9 text-center min-h-0 md:min-h-[180px] flex flex-col items-center">

                  <FaFileAlt className="text-3xl sm:text-4xl text-teal-600 mx-auto mb-2 sm:mb-3" />

                  <h3 className="font-bold text-[#10243e]">
                    Post a Job
                  </h3>

                  <p className="text-sm text-gray-500 mt-2 leading-5">
                    Create a job listing with your requirements in minutes.
                  </p>

                </div>

              </div>


              {/* STEP 2 */}
              <div className="relative min-w-0">

                <div className="absolute top-3 left-3 sm:-top-5 sm:left-1/2 sm:-translate-x-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#e4f1ff] border border-blue-200 flex items-center justify-center font-bold text-blue-600 z-10">
                  2
                </div>

                <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-5 pt-8 sm:pt-9 text-center min-h-0 md:min-h-[180px] flex flex-col items-center">

                  <FaUsers className="text-3xl sm:text-4xl text-teal-600 mx-auto mb-2 sm:mb-3" />

                  <h3 className="font-bold text-[#10243e]">
                    Receive Applications
                  </h3>

                  <p className="text-sm text-gray-500 mt-2 leading-5">
                    Get applications from verified and skilled
                    healthcare professionals.
                  </p>

                </div>

              </div>


              {/* STEP 3 */}
              <div className="relative min-w-0">

                <div className="absolute top-3 left-3 sm:-top-5 sm:left-1/2 sm:-translate-x-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#e4f1ff] border border-blue-200 flex items-center justify-center font-bold text-blue-600 z-10">
                  3
                </div>

                <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-5 pt-8 sm:pt-9 text-center min-h-0 md:min-h-[180px] flex flex-col items-center">

                  <FaCheckCircle className="text-3xl sm:text-4xl text-teal-600 mx-auto mb-2 sm:mb-3" />

                  <h3 className="font-bold text-[#10243e]">
                    Hire the Best
                  </h3>

                  <p className="text-sm text-gray-500 mt-2 leading-5">
                    Review profiles, shortlist candidates and build
                    your team.
                  </p>

                </div>

              </div>

            </div>


            {/* POST JOB BUTTON */}
            <div className="flex justify-center mt-5 sm:mt-6">

              <button
                onClick={() => openLoginModal("institution")}
                className="w-full sm:w-auto justify-center bg-teal-600 hover:bg-teal-700 text-white px-6 sm:px-10 py-3 rounded-xl font-semibold flex items-center gap-3 transition"
              >
                Post a Job
                <FaArrowRight className="text-sm" />
              </button>

            </div>

          </div>

        </div>

      </section>


      {/* ================= BENEFITS ================= */}
      <section className="bg-white py-4 sm:py-5">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">

            {/* VERIFIED */}
            <div className="flex items-center gap-3 sm:gap-4 px-1 sm:px-5 py-3 sm:py-4 border-b lg:border-b-0 lg:border-r border-gray-200">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border border-teal-200 bg-[#f0fcfa] flex items-center justify-center flex-shrink-0">
                <FaShieldAlt className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div>
                <h3 className="font-bold text-[#10243e]">
                  Verified Profiles
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Trusted and verified professionals
                </p>
              </div>

            </div>


            {/* SAVE TIME */}
            <div className="flex items-center gap-3 sm:gap-4 px-1 sm:px-5 py-3 sm:py-4 border-b lg:border-b-0 lg:border-r border-gray-200">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border border-teal-200 bg-[#f0fcfa] flex items-center justify-center flex-shrink-0">
                <FaClock className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div>
                <h3 className="font-bold text-[#10243e]">
                  Save Time
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Streamlined hiring process
                </p>
              </div>

            </div>


            {/* TALENT */}
            <div className="flex items-center gap-3 sm:gap-4 px-1 sm:px-5 py-3 sm:py-4 border-b lg:border-b-0 lg:border-r border-gray-200">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border border-teal-200 bg-[#f0fcfa] flex items-center justify-center flex-shrink-0">
                <FaUsers className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div>
                <h3 className="font-bold text-[#10243e]">
                  Wide Talent Pool
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Across multiple healthcare roles
                </p>
              </div>

            </div>


            {/* SUPPORT */}
            <div className="flex items-center gap-3 sm:gap-4 px-1 sm:px-5 py-3 sm:py-4">

              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border border-teal-200 bg-[#f0fcfa] flex items-center justify-center flex-shrink-0">
                <FaHeadset className="text-2xl sm:text-3xl text-teal-600" />
              </div>

              <div>
                <h3 className="font-bold text-[#10243e]">
                  Dedicated Support
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Assistance whenever you need
                </p>
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= FOOTER ================= */}
      <Footer />
      <LoginModal
  isOpen={showLoginModal}
  initialRole={loginRole}
  onClose={() => setShowLoginModal(false)}
/>

    </div>
    
    
  );
}

export default HowItWorks;